import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ButtonDirective } from '../../directives/button.directive';

import { environment } from '../../../../environments/environment';
import { ThemeService } from '../../../core/services/theme/theme.service';

@Component({
  selector: 'app-theme-selector',
  templateUrl: './theme-selector.component.html',
  styleUrl: './theme-selector.component.scss',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    ButtonDirective,
  ],
})
export class ThemeSelectorComponent {
  readonly themeService = inject(ThemeService);

  // Detect if we are in local environment
  readonly isLocal = environment.local;

  selectTheme(theme: string | 'none'): void {
    if (theme === 'none') {
      this.themeService.clearTheme();
    } else {
      this.themeService.setThemeForDevelopment(theme);
    }
  }
}
